import { render, staticRenderFns } from "./statusInstructions.vue?vue&type=template&id=80c1bea2&"
import script from "./statusInstructions.vue?vue&type=script&lang=js&"
export * from "./statusInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports